import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import styles from '../../theme/styles';

const LoadingScreen = (props) => {
  const { classes, title = 'Loading' } = props;

  return (
    <div className={classes.loadingScreenContainer}>
      <div className={classes.loadingScreenSpinnerContainer}>
        <CircularProgress size={100} />
      </div>
      {Array.isArray(title) ? (
        title.map((line, index) => (
          <Typography
            key={index}
            style={index !== 0 ? { paddingTop: '12px' } : {}}
          >
            {line}
          </Typography>
        ))
      ) : (
        <Typography>{title}</Typography>
      )}
    </div>
  );
};

LoadingScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

export default withStyles(styles)(LoadingScreen);
